export enum EntityType {
  ATHLETE = "ATHLETE",
  GROUP = "GROUP",
}
